import React from 'react';
import { Cover, Button } from 'seduo-ui';
const Example = () => (<Cover color="brand-dark" title="This is hero text small" titleSmall withBackgroundImage leftButton={<Button color="primary" block>
                Primary button link
            </Button>}>
        <picture>
            <source media="(max-width: 767px)" srcSet="https://seduocz.educdn.cz/static/images/employer/ipad_mobile@1x.png, https://seduocz.educdn.cz/static/images/employer/ipad_mobile@2x.png 2x"/>
            <img src="https://seduocz.educdn.cz/static/images/employer/ipad@1x.png" srcSet="https://seduocz.educdn.cz/static/images/employer/ipad@1x.png, https://seduocz.educdn.cz/static/images/employer/ipad@2x.jpg 2x" className="w-100" alt="Jednoduchá administrace pro správu studentů, studijní plány a reporting."/>
        </picture>
    </Cover>);
export default Example;
